import { render, staticRenderFns } from "./export-expert-products.vue?vue&type=template&id=f8aa1aee&"
import script from "./export-expert-products.vue?vue&type=script&lang=js&"
export * from "./export-expert-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports